let base_url: string;
let base_ml_url: string;

if (process.env.VUE_APP_BASE_URL) {
  base_url = process.env.VUE_APP_BASE_URL;
} else {
  base_url = "localhost";
}

if (process.env.VUE_APP_ML_URL) {
  base_ml_url = process.env.VUE_APP_ML_URL;
} else {
  base_ml_url = "localhost";
}
export const BASE_URL = base_url;
export const BASE_URL_ML = base_ml_url;
